import { useOfficeContext } from "./hooks/useOfficeContext";
import { useAddinConfig } from "./hooks/useAddinConfig";
import { LoadingState } from "./components/LoadingState";
import { ErrorState } from "./components/ErrorState";
import { ActiveUser } from "./components/ActiveUser";
import { DisabledUser } from "./components/DisabledUser";
import { NonCustomer } from "./components/NonCustomer";
import { NotInOutlook } from "./components/NotInOutlook";

export default function App() {
  const { isReady, userEmail, error: officeError, isOutsideOffice } = useOfficeContext();
  const { config, isLoading, error: configError, refetch } = useAddinConfig(userEmail);

  // Opened outside Outlook (e.g. directly in a browser) -> friendly landing page
  if (isOutsideOffice) {
    return <NotInOutlook />;
  }

  // Office.js not ready yet
  if (!isReady && !officeError) {
    return <LoadingState />;
  }

  // Office.js error
  if (officeError) {
    return <ErrorState message={officeError} />;
  }

  // Loading config
  if (isLoading) {
    return <LoadingState />;
  }

  // Config error
  if (configError) {
    return <ErrorState message={configError} onRetry={refetch} />;
  }

  // No config (shouldn't happen, but handle gracefully)
  if (!config) {
    return <ErrorState message="Unable to load configuration" onRetry={refetch} />;
  }

  // Active customer
  if (config.enabled) {
    return <ActiveUser config={config} />;
  }

  // Not registered (non-customer)
  if (config.reason === "not_registered") {
    return <NonCustomer config={config} />;
  }

  // Disabled user (inactive, subscription issue, or toggle off)
  return <DisabledUser config={config} />;
}
